ANTRAGSGRUEN_STRINGS = {
    "std": {
        "add_tag": "Create",
        "del_confirm": "Really delete it?",
        "draft_del": "Delete draft",
        "draft_del_confirm": "Really delete this draft?",
        "draft_date": "Draft date",
        "draft_restore_confirm": "Really restore this draft?",
        "min_x_supporter": "You have to enter at least %NUM% supporters.",
        "missing_resolution_date": "A resolution date has to be entered.",
        "missing_gender": "Please select one choice in the field Gender.",
        "pw_x_chars": "The password needs to be at least %NUM% characters long.",
        "pw_min_x_chars": "Min. %NUM% characters",
        "pw_no_match": "The passwords do not match.",
        "leave_changed_page": "There are unsaved changes. Do you really want to leave this page and discard those changes?",
        "moved_paragraph_from": "Moved from paragraph ##PARA##",
        "moved_paragraph_to": "Moved to paragraph ##PARA##",
        "moved_paragraph_from_line": "Moved from paragraph ##PARA## (line ##LINE##)",
        "moved_paragraph_to_line": "Moved to paragraph ##PARA##(line ##LINE##)"
    },
    "merge": {
        "initiated_by": "Proposed by",
        "title_open_in_blank": "Open the amendment in a new window",
        "title_del_title": "Remove the headline \"Colliding Amendment: ...\"",
        "title_del_colliding": "Remove the whole colliding paragraph",
        "title": "Headline",
        "change_accept": "Accept",
        "change_reject": "Reject",
        "colliding_title": "Colliding amendm.",
        "colliding_start": "Collisions start here",
        "colliding_end": "Collisions end here",
        "reloadParagraph": "If this selection is changed, manual changes to this paragraph are lost. Proceed?",
        "mergedCollisionHint": "This change collides with a previous one. Please be cautious to get a consistent text in the end.",
        "modU": "Proposed modification"
    },
    "admin": {
        "adminMayEditConfirm": "If this is deactivated, this cannot be undone for all motions created up to now.",
        "deleteDataConfirm": "Really delete this?",
        "removeAdminConfirm": "Do you really want to remove admin right from this user?",
        "removeUserConfirm": "Do you really want to remove the user %NAME% from THIS consultation? Submitted motions etc. will remain in the system and need to be removed manually.",
        "deleteUserConfirm": "Do you really want to delete the user %NAME%? Submitted motions etc. will remain in the system and need to be removed manually.",
        "emailMissingCode": "The text needs to contain the code %ACCOUNT%.",
        "emailMissingLink": "The text needs to contain the code %LINK%.",
        "emailMissingTo": "No e-mail-address was entered.",
        "emailMissingUsername": "No username was entered.",
        "emailNumberMismatch": "The number of names and e-mail-addresses does not match.",
        "delMotionConfirm": "Do you really want to delete this motion?",
        "delAmendmentConfirm": "Do you really want to delete this amendment?",
        "delPageConfirm": "Do you really want to delete this page?",
        "deleteMotionSectionConfirm": "Do you really want to delete this section? It will be deleted from all motions of this motion type.",
        "consDeleteConfirm": "Do you really want to delete this consultation, including all motions and amendments?",
        "gotoUpdateModeConfirm": "Do you want to enable the update mode? While the update mode is active, this installation of Antragsgrün will be unavailable for all users."
    }
};
